var link_viewer_default = {
  "fontElementMap": "gY8iu",
  "link": "lE2Je",
  "linkInEditor": "_7pXFi",
  "linkInViewer": "B1l72",
  "toolbarUrlContainer": "_5V0g2",
  "toolbarUrl": "la3Hc",
  "toolbarUrlAnchor": "hcriK"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
